import React from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';

/**
 * HubspotChat
 *
 * HubSpot is the contact channel for the EN site (chat widget). Its tracking
 * script loads on every page regardless of the browser language, but on PT we
 * render the WhatsApp button instead — so the HubSpot chat launcher must stay
 * hidden there. Otherwise its (invisible) iframe container sits on top of the
 * WhatsApp button and captures the clicks, leaving it unclickable (issue #1376).
 *
 * The contact channel is decided solely by the site locale (`router.locale`),
 * never by the browser language, so the site locale always wins.
 */
const HubspotChat: React.FC = () => {
  const router = useRouter();
  // PT locale shows the WhatsApp button (rendered by WhatsAppChat), so the
  // HubSpot launcher stays hidden to avoid covering it. EN locale shows the
  // HubSpot chat.
  const hideChat = router.locale === 'pt';

  return (
    <>
      {/* Persistent rule (beats HubSpot's inline styles and survives the widget
          re-applying them, unlike a one-shot JS toggle) so the chat launcher
          never covers the WhatsApp button in PT. `pointer-events`/`visibility`
          are separate properties HubSpot does not set inline, so this stylesheet
          `!important` wins decisively: even if HubSpot forces `display` inline,
          clicks still pass through to the WhatsApp button beneath it. */}
      {hideChat && (
        <style>{`#hubspot-messages-iframe-container { display: none !important; visibility: hidden !important; pointer-events: none !important; }`}</style>
      )}
      <Script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src={`//js.hs-scripts.com/${process.env.NEXT_PUBLIC_HUBSPOT_TRACKING_ID}.js`}
      />
    </>
  );
};

export default HubspotChat;
